module.exports = __webpack_public_path__ + "img/Contacts.svg.0e25422d.png";